import React from "react";
// Upewnij się, że ścieżka do pliku CSS jest poprawna dla struktury Twojego projektu
import './../style/rodo.css';

function Rodo() {
    return (
        <div className="rodo-container">
            <h2 className="rodo-title" style={{ textAlign: "center", fontWeight: "bold" }}>Klauzula informacyjna RODO</h2>

            <p className="rodo-paragraph">
                Zgodnie z art. 13 ust. 1 i 2 Rozporządzenia Parlamentu Europejskiego i Rady (UE) 2016/679 o ochronie danych osobowych z dnia 27 kwietnia 2016 r. w sprawie ochrony osób fizycznych w związku z przetwarzaniem danych osobowych i w sprawie swobodnego przepływu takich danych oraz uchylenia dyrektywy 95/46/WE (dalej „RODO”), informujemy, że:
            </p>

            <ol className="rodo-list" style={{ paddingLeft: "40px" }}>
                <li style={{ marginBottom: "15px" }}>
                    Administratorem Pani/Pana danych osobowych jest firma Humane & Business Progress Spółka z ograniczoną odpowiedzialnością (HaBP) z siedzibą przy ul. Sekwojowej 2/1, 05-509 Józefosław, NIP: 1231198132, REGON: 142089346.
                </li>

                <li style={{ marginBottom: "15px" }}>
                    W sprawach ochrony danych osobowych można skontaktować się z Koordynatorem Ochrony Danych pod adresem e-mail: <a href="mailto:biuro@habp.pl">biuro@habp.pl</a>
                </li>

                <li style={{ marginBottom: "15px" }}>
                    Monitoringiem wizyjnym objęte są obszary wokół budynku przy ul. Sekwojowej 2/1, 05-509 Józefosław, ciągi komunikacyjne i kluczowe pomieszczenia.
                </li>

                <li style={{ marginBottom: "15px" }}>
                    Przez obszar objęty monitoringiem wizyjnym rozumie się:
                </li>

                <li style={{ marginBottom: "15px" }}>
                    Wszystkie dane rejestrowane poprzez kamery monitoringu wizyjnego zapisywane są na rejestratorze danych i są dostępne przez 3 miesiące od dnia nagrania. Po tym terminie dane zostają automatycznie nadpisywane. Rejestracji i zapisowi danych na nośniku podlega tylko obraz (bez dźwięku).
                </li>

                <li style={{ marginBottom: "15px" }}>
                    Dla celów dowodowych HaBP ma możliwość zabezpieczenia zdarzenia zarejestrowanego przez monitoring wizyjny, które zagrażało bezpieczeństwu, życiu i zdrowiu pracowników i interesantów lub dotyczyło niszczenia i kradzieży mienia:

                    <ul style={{ listStyleType: "none", paddingLeft: "15px", marginTop: "10px" }}>
                        <li style={{ marginBottom: "5px" }}>a) na wniosek osób trzecich;</li>
                        <li style={{ marginBottom: "5px" }}>b) na wniosek organów prowadzących postępowania;</li>
                        <li style={{ marginBottom: "5px" }}>c) na wniosek Kierownika jednostki,</li>
                    </ul>
                </li>

                <li style={{ marginBottom: "15px" }}>
                    Każdorazowe zabezpieczenie zdarzeń zarejestrowanych przez monitoring wizyjny odbywa się na pisemny wniosek złożony do Kierownika jednostki.
                </li>

                <li style={{ marginBottom: "15px" }}>
                    Zabezpieczone dane z monitoringu wizyjnego są udostępniane tylko organom prowadzącym postępowanie w sprawie zarejestrowanego zdarzenia np. policji, prokuraturze, sądom, które działają na podstawie odrębnych przepisów.
                </li>

                <li style={{ marginBottom: "15px" }}>
                    Pani/Pana dane osobowe przetwarzane będą, w celu zapewnienia bezpieczeństwa i porządku publicznego oraz ochrony osób i mienia na podstawie art. 6 ust. 1 lit. e rozporządzenia Parlamentu Europejskiego i Rady (UE) 2016/679 z 27 kwietnia 2016 r. w sprawie ochrony osób fizycznych w związku z przetwarzaniem danych osobowych i w sprawie swobodnego przepływu takich danych oraz uchylenia dyrektywy 95/46/WE (RODO) oraz na postawie art. 22² § 1 ustawy z dnia 26 czerwca 1974 roku - Kodeks pracy.
                </li>

                <li style={{ marginBottom: "15px" }}>
                    Pani/Pana dane osobowe mogą być udostępnianie wyłącznie organom uprawnionym do ich otrzymania na podstawie przepisów obowiązującego prawa.
                </li>

                <li style={{ marginBottom: "15px" }}>
                    Pani/Pana dane osobowe nie będą przekazywane do państw spoza Europejskiego Obszaru Gospodarczego, który tworzą państwa Unii Europejskiej oraz Islandia, Norwegia i Lichtenstein.
                </li>

                <li style={{ marginBottom: "15px" }}>
                    Wobec Pani/Pana osoby nie będą podejmowane zautomatyzowane decyzje (decyzje bez istotnego udziału człowieka), w tym Pana/Pani dane osobowe nie będą podlegały profilowaniu.
                </li>

                <li style={{ marginBottom: "15px" }}>
                    Przysługuje Pani/Panu prawo wniesienia skargi do organu nadzorczego – Prezesa Urzędu Ochrony Danych Osobowych, w przypadku gdy przetwarzanie Pani/Pana danych osobowych narusza przepisy dotyczące ochrony danych osobowych.
                </li>
            </ol>
        </div>
    );
}

export default Rodo;
